import React, {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom';
import Navbar from '../../component/Navbar'
import "./voucherlist.style.css"
import {loadState, queryStringBuilder} from '../../_helpers'
import {voucherServices} from "../../_services";
import Layout from '../../component/Layout'
import Loading from "../../component/Loading"

const VoucherList = () => {
    let navigate = useNavigate();
    const [voucherList, setVoucherList] = useState([])
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let sessionId = loadState('sessionId').replace(/"/g, ' ')
        let memberType = loadState('memberType').replace(/"/g, ' ')
        let memberGroup = loadState('memberGroup').replace(/"/g, ' ')
        let memberId = loadState('memberId').replace(/"/g, '')
        let cardNumber = loadState('cardNumber').replace(/"/g, '')

        let payload = {
            userId: memberId,
            memberType: memberType,
            memberGroup: memberGroup,
            sessionId: sessionId,
            cardNumber: cardNumber
        }
        setLoading(true)
        voucherServices.getVoucher(queryStringBuilder(payload)).then(result => {
            if (result.status === 200)
                setVoucherList(result.message)
                setLoading(false)
        }).catch(err => {
                setLoading(false)
        })
    }, [])
    return (
        <Layout>
            <Navbar title="Pilih Voucher"/>
            {loading && <Loading />}
            {voucherList.length > 0 ? voucherList.map((value, index) => {
                return (
                    <div key={index} className="columns is-mobile card-voucher" onClick={() => navigate("/voucher-detail", {
                        state: value
                    })}>
                        <div className="column is-5">
                            <img src={value.thumbnailUrl !== null  && value.thumbnailUrl !== "" ? value.thumbnailUrl : "https://bulma.io/images/placeholders/1280x960.png"  } alt="Placeholderimage"/>
                        </div>
                        <div className="column">
                            <div className="voucher-description">
                                <div className="has-text-black">
                                    <p>{value.merchantName}</p>
                                    <p>{value.productDescription}</p>
                                </div>
                                <div className="has-text-link">
                                    {/* <p>Sudah digunakan</p> */}
                                </div>
                            </div>
                        </div>
                    </div>)
            }) : null}
        </Layout>
    )
}

export default VoucherList
